<template>
    <div class="uk-margin-xsmall-top">
        <label class="uk-cursor-pointer"
               :class="{ checked: filterItem.status_checked }">
            <input class="uk-checkbox uk-margin-xsmall-right"
                   type="checkbox"
                   :checked="filterItem.status_checked"
                   @change.stop="event => setValue(filterIndex, itemIndex, event.target.checked, filterItem, filterId)"
            > {{ $t("filters." + filterItemKey) }}
        </label>
    </div>
</template>


<script>
    export default {
        name: "dr-checkbox",
        props: [
            'filterItem', 'filterIndex', 'itemIndex', 'filterId', 'filterItemKey'
        ],
        methods: {
            setValue(filterIndex, itemIndex, value, filterItem, filterId) {
                this.$store.dispatch('setCheckboxesQueryParams', { filterIndex, itemIndex, value, filterItem, filterId });
            }
        }

    }
</script>

<style lang="scss">
    .uk-cursor-pointer {
        color: #a2a2a2;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 1.26;
        letter-spacing: -.28px;
        transition: all .15s ease-in-out;

        &:hover {
            text-decoration: none;
            background-color: transparent;
            color: #6c6a6b;
        }

        &.checked {
            background-color: transparent;
            color: #0b0b0b;
        }
    }

    .uk-checkbox {
        margin-bottom: 0;
        position: relative;
        padding-left: 15px;
        display: inline-block;
        width: auto;
        box-sizing: border-box;
        text-align: left;
        border: none !important;
        height: 15px !important;
        border-radius: 0;

        &:checked {
            background-image: none !important;
        }

        &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 15px; // Checkbox size
        height: 15px;
        border-radius: 2px;
        border: 1px solid #a2a2a2;
        background: transparent; // Default background
        box-sizing: border-box;
        }

        &::after {
        content: "";
        position: absolute;
        left: 4px;
        top: 50%;
        transform: translateY(-50%);
        width: 7px;
        height: 7px;
        border-radius: 1px;
        background: transparent;
        }

        &:checked::after {
        background: #a6b0ff; // Fill the checkbox when active
        }
    }
</style>

